/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// CSS Import
import "./index.css";

// REDUX Import
import { getAllDevices } from "../../../redux/features/devices/devices";

// COMPONENTS Imports
import CommonToast from "../../../components/_utils/CommonToast";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent";
import PaginationComponent from "../../../components/_utils/PaginationComponent";
import Loader from "../../../components/Loader/Index";
import MyDeviceCard from "../../../components/MyDevices/MyDeviceCard";
import { GlobalConfiguration } from "../../../utils/configurationProvider";
import ICONS from "../../../assets/Icons";

function MyDevices() {
  // useLocation
  const location = useLocation();

  // useDispatch
  const dispatch = useDispatch();

  // useRef
  const isFirstRender = useRef(true);

  // navigate
  const navigate = useNavigate();

  // useState
  const [allDevicesData, setAllDevicesData] = useState([]);
  const [allDevices, setAllDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [mainData, setMainData] = useState([]);
  const [pageSize, setPageSize] = useState(
    window.innerWidth >= 3840 ? 192 : window.innerWidth >= 2560 ? 102 : 50,
  );
  const [totalCount, setTotalCount] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOptions] = useState([50, 100]);
  const [selectedValue, setSelectedValue] = useState(50);
  const [dataFetched, setDataFetched] = useState(false);

  // useSelector
  const services = useSelector((state) => state.refreshToken.services);
  const allDevicesDataLoading = useSelector(
    (state) => state.devices.allDevicesDataLoading,
  );

  const isDeviceDeleted = location.state
    ? location.state.isDeviceDeleted
    : false;

  // useEffect
  useEffect(() => {
    if (isDeviceDeleted) {
      toast.dismiss();
      CommonToast({
        text: "Device deleted successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
      });
      navigate("/settings/devices_view_all");
    }
  }, []);

  useEffect(() => {
    if (!services) return;

    if (!services.includes("Sup_VDevice")) {
      navigate("/feature_not_assigned");
      return;
    }

    getLoggedInDevices();
  }, [currentPage, pageSize]);

  useEffect(() => {
    const newTotalPages = Math.ceil(totalCount / pageSize);

    setCurrentPage((prevPage) => {
      if (newTotalPages === 0) {
        return 1;
      }
      if (prevPage > newTotalPages) {
        return newTotalPages;
      }
      return prevPage;
    });
  }, [totalCount, pageSize]);

  const getLoggedInDevices = async () => {
    if (!isFirstRender?.current) {
      setLoading(true);
    }

    setDataFetched(false);

    try {
      if (!services || services?.length === 0) {
        return;
      }

      if (services?.includes("Sup_VDevice")) {
        const response = await dispatch(
          getAllDevices({ page_no: currentPage, page_size: pageSize }),
        );

        if (response?.payload) {
          setMainData(response?.payload);
          setAllDevicesData(response?.payload);
          setTotalCount(response?.payload?.total_count || 0);
          setAllDevices(response?.payload?.devices || []);
          setDataFetched(true);
        } else {
        }
      } else {
      }
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handlePagination = (page) => {
    setCurrentPage(page);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    setSelectedValue(value);
    setPageSize(value);
    setCurrentPage(Number(GlobalConfiguration.lengthCheckOne) || currentPage);
    toggleDropdown();
  };
  return (
    <>
      <div className="bg-primary-bg flex flex-col h-screen">
        <div className="w-full fixed bottom-bottom-base z-z-index-max">
          {
            <div
              style={{
                zIndex: "var(--z-index-max)",
                width: "var(--width-full)",
                bottom: "var(--bottom-base)",
                borderRadius: "var(--border-none)",
                borderBottomRightRadius: "var(--border-none)",
                borderBottomLeftRadius: "var(--border-none)",
              }}
              className="fixed w-full"
            >
              <PaginationComponent
                handleSelect={handleSelect}
                selectedValue={selectedValue}
                data={mainData}
                pageSize={pageSize}
                dropdownOptions={dropdownOptions}
                handlePagination={handlePagination}
                currentPage={currentPage}
                setIsOpen={setIsOpen}
              />
            </div>
          }
        </div>

        <div className="h-navbar-breadcrumb-height Qsmd:block hidden bg-primary-nav"></div>
        <div className="devices_div_container">
          <div className="devices_div ">
            <TopNavComponent
              isFormattingNotRequired={true}
              isSelectionView
              topNavHeader={Number(
                allDevicesData?.total_count ?? 0,
              ).toLocaleString("en-IN")}
              topNavSubText="Total devices"
              selectionText="Note: Device currently in use is highlighted in orange."
              handleBack={() => navigate(-1)}
            />
          </div>
        </div>
        <div
          className={`flex flex-1 flex-col h-full mb-[var(--pagination-height)] overflow-y-scroll scroll-py-top_md`}
        >
          {loading || allDevicesDataLoading ? (
            <div className="m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : dataFetched && allDevices?.length > 0 ? (
            <>
              <MyDeviceCard data={allDevices} />
            </>
          ) : dataFetched ? (
            <div className="flex flex-col items-center justify-center m-auto">
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No device found"
                className="w-graphic-width-md h-graphic-rectangle-height-md"
              />
              <p className="devices-acc-no-devicesaccount-text py-padding-sm">
                No devices found.
              </p>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default MyDevices;
